import React, { useEffect, useState } from "react";
import { CustomerLayout } from "@/components/Layout/CustomerLayout";
import api from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { Bell, Check } from "lucide-react";

export default function Notifications() {
  const { t } = useLang();
  const [list, setList] = useState([]);
  const load = () => api.get("/notifications").then(r => setList(r.data));
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <CustomerLayout>
      <div className="max-w-xl mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">{t("notifications")}</h1>
          <button onClick={markAll} className="text-sm text-[var(--so-orange)] font-semibold" data-testid="mark-all-read">{t("markAllRead")}</button>
        </div>
        {list.length === 0 ? (
          <div className="text-center py-20 text-[var(--so-text-soft)]">
            <Bell className="w-12 h-12 mx-auto opacity-30" />
            <div className="mt-3">No notifications yet</div>
          </div>
        ) : (
          <div className="mt-4 space-y-2">
            {list.map((n) => (
              <div key={n.id} className={`so-card p-3 flex gap-3 ${n.read ? "opacity-60" : ""}`} data-testid={`notif-${n.id}`}>
                <div className="w-9 h-9 rounded-full bg-[var(--so-orange)]/10 text-[var(--so-orange)] flex items-center justify-center flex-shrink-0">
                  <Bell className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm">{n.title}</div>
                  <div className="text-xs text-[var(--so-text-soft)]">{n.body}</div>
                  <div className="text-[10px] text-[var(--so-text-soft)] mt-1">{new Date(n.created_at).toLocaleString()}</div>
                </div>
                {n.read && <Check className="w-4 h-4 text-emerald-500" />}
              </div>
            ))}
          </div>
        )}
      </div>
    </CustomerLayout>
  );
}
